import { ContextApi } from 'contexts/Localization/types'
import { PageMeta } from './types'

export const DEFAULT_META: PageMeta = {
  title: 'lrb',
  description:
    'The most popular AMM on LRB by user count! Earn Lora-LP through yield farming or win it in the Lottery, then stake it in Syrup Pools to earn more tokens! Initial Farm Offerings (new token launch model pioneered by lrb), NFTs, and more, on a platform you can trust.',
  image: 'images/hero.png',
}

export const getCustomMeta = (path: string, t: ContextApi['t']): PageMeta => {
  let basePath
  if (path.startsWith('/swap')) {
    basePath = '/swap'
  } else if (path.startsWith('/add')) {
    basePath = '/add'
  } else if (path.startsWith('/remove')) {
    basePath = '/remove'
  } else if (path.startsWith('/teams')) {
    basePath = '/teams'
  } else if (path.startsWith('/voting/proposal') && path !== '/voting/proposal/create') {
    basePath = '/voting/proposal'
  } else if (path.startsWith('/nfts/collections')) {
    basePath = '/nfts/collections'
  } else if (path.startsWith('/nfts/profile')) {
    basePath = '/nfts/profile'
  } else if (path.startsWith('/pancake-squad')) {
    basePath = '/pancake-squad'
  } else {
    basePath = path
  }

  switch (basePath) {
    case '/':
      return {
        title: `${t('Home')} | ${t('LORASwap')}`,
      }
    case '/swap':
      return {
        title: `${t('Exchange')} | ${t('LORASwap')}`,
      }
    case '/add':
      return {
        title: `${t('Add Liquidity')} | ${t('LORASwap')}`,
      }
    case '/remove':
      return {
        title: `${t('Remove Liquidity')} | ${t('LORASwap')}`,
      }
    case '/liquidity':
      return {
        title: `${t('Liquidity')} | ${t('LORASwap')}`,
      }
    case '/find':
      return {
        title: `${t('Import Pool')} | ${t('LORASwap')}`,
      }
    case '/competition':
      return {
        title: `${t('Trading Battle')} | ${t('LORASwap')}`,
      }
    case '/prediction':
      return {
        title: `${t('Prediction')} | ${t('LORASwap')}`,
      }
    case '/prediction/leaderboard':
      return {
        title: `${t('Leaderboard')} | ${t('LORASwap')}`,
      }
    case '/farms':
      return {
        title: `${t('Farms')} | ${t('LORASwap')}`,
      }
    case '/farms/auction':
      return {
        title: `${t('Farm Auctions')} | ${t('LORASwap')}`,
      }
    case '/pools':
      return {
        title: `${t('Pools')} | ${t('LORASwap')}`,
      }
    case '/lottery':
      return {
        title: `${t('Lottery')} | ${t('LORASwap')}`,
      }
    case '/ifo':
      return {
        title: `${t('Initial Farm Offering')} | ${t('LORASwap')}`,
      }
    case '/teams':
      return {
        title: `${t('Leaderboard')} | ${t('LORASwap')}`,
      }
    case '/voting':
      return {
        title: `${t('Voting')} | ${t('LORASwap')}`,
      }
    case '/voting/proposal':
      return {
        title: `${t('Proposals')} | ${t('LORASwap')}`,
      }
    case '/voting/proposal/create':
      return {
        title: `${t('Make a Proposal')} | ${t('LORASwap')}`,
      }
    case '/info':
      return {
        title: `${t('Overview')} | ${t('LORASwap Info & Analytics')}`,
        description: 'View statistics for lrb exchanges.',
      }
    case '/info/pools':
      return {
        title: `${t('Pools')} | ${t('LORASwap Info & Analytics')}`,
        description: 'View statistics for lrb exchanges.',
      }
    case '/info/tokens':
      return {
        title: `${t('Tokens')} | ${t('LORASwap Info & Analytics')}`,
        description: 'View statistics for lrb exchanges.',
      }
    case '/nfts':
      return {
        title: `${t('Overview')} | ${t('LORASwap')}`,
      }
    case '/nfts/collections':
      return {
        title: `${t('Collections')} | ${t('LORASwap')}`,
      }
    case '/nfts/activity':
      return {
        title: `${t('Activity')} | ${t('LORASwap')}`,
      }
    case '/nfts/profile':
      return {
        title: `${t('Profile')} | ${t('LORASwap')}`,
      }
    case '/pancake-squad':
      return {
        title: `${t('Pancake Squad')} | ${t('LORASwap')}`,
      }
    default:
      return null
  }
}
